import { CRM_API, RequestHelper } from "utils";
const PROCESO_API = "Proceso";

export const ProcesoService = (() => {
  const listado = function (args) {
    return new Promise((res) => res(args)).then((params) => {
      return RequestHelper(CRM_API).get(PROCESO_API, params);
    });
  };

  const procesoAutomaticos = (() => {
    return new Promise((res) => res()).then(() => {
      return RequestHelper(CRM_API).get(`${PROCESO_API}/ProcesosAutomaticos`);
    });
  });

  const ejecutarProceso = ((args) => {
    return new Promise((res) => res(args)).then(() => {
      return RequestHelper(CRM_API).post(`${PROCESO_API}/EjecutarProceso`, args);
    });
  });

  return {
    listado,
    procesoAutomaticos,
    ejecutarProceso
  };
})();
